module.exports = __webpack_public_path__ + "img/ic_calendar_bolder.15d35e44.svg";